import { Injectable } from '@angular/core';
import { WilsonState } from '@wilson/non-domain-specific/decorators/wilson-state';
import { startOfDay } from 'date-fns';
import { map, Observable } from 'rxjs';

type UserId = string;

@Injectable({
  providedIn: 'root',
})
export class TimelineCellHighlightService {
  @WilsonState<Record<UserId, Date[]>>({})
  private cellToHighlight!: Record<UserId, Date[]>;
  private cellToHighlight$!: Observable<Record<UserId, Date[]>>;

  public getUserCellsToHighlight(userId: string): Observable<Date[]> {
    return this.cellToHighlight$.pipe(map((map) => map[userId] || []));
  }

  public clearCellsFromHighlight(): void {
    this.cellToHighlight = {};
  }

  public setCellToHighlight(userId: string, date: string): void {
    const dateToHighlight = startOfDay(new Date(date));
    this.cellToHighlight = {
      ...this.cellToHighlight,
      [userId]: [...(this.cellToHighlight[userId] || []), dateToHighlight],
    };
  }

  public removeCellFromHighlight(userId: string, date: string): void {
    const dateToRemove = startOfDay(new Date(date));
    this.cellToHighlight = {
      ...this.cellToHighlight,
      [userId]: this.cellToHighlight[userId].filter(
        (d) => d.getTime() !== dateToRemove.getTime(),
      ),
    };
  }
}
